export const string = {
    error: {
      network_error: 'Network error',
      failed_due_to_internal_error: 'Failed due to internal error',
      please_login_to_your_account: 'Please login to your account',
    },
  };
  